import { render, staticRenderFns } from "./formInSitu.vue?vue&type=template&id=5aa4cb28&"
import script from "./formInSitu.vue?vue&type=script&lang=js&"
export * from "./formInSitu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports